import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  // app bar
  appBar: {
    [theme.breakpoints.down('sm')]: {
      padding: '0 10px',
    },
    zIndex: 3,
    padding: '0 24px',
    backgroundColor: 'transparent',
  },
  whiteBg: {
    backgroundColor: 'white',
  },
  toolBar: {
    backgroundColor: 'white',
    maxWidth: 1440,
    borderBottom: '1px solid',
  },
  toolBarGutters: {
    width: '100%',
    margin: 'auto',
    borderColor: '#c2c2c2',
    padding: 0,
  },
  toolBarGuttersSecondary: {
    backgroundColor: 'transparent',
    border: 0,
  },

  //buttons
  iconButton: {
    width: 42,
    height: 42,
  },
  menuButton: {
    width: 90,
    borderRadius: 15,
    marginRight: 10,
  },
  languageSwitchButton: {
    borderRadius: '100%',
    width: 26,
    height: 26,
    minWidth: 'unset',
  },
  loginButton: {},
  loginButtonSecondary: {
    color: 'white',
    border: '1px solid white',
    '&:hover': {
      border: '1px solid white',
    },
  },
  siginUpButton: {
    color: 'white',
  },
  outlinedSecondary: {
    color: 'white',
    border: '1px solid white',
    '&:hover': {
      border: '1px solid white',
    },
  },
  containedSecondary: {
    color: theme.palette.primary.main,
    borderRadius: 15,
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  shoppingCartIconSecondary: {
    color: 'white',
  },
  userBadgeSecondaryButton: {
    color: 'white',
  },

  // badges hack for material ui css specificity
  userLink: {
    '& $orderBadge': {
      top: 5,
      right: 5,
      width: 20,
      height: 20,
      paddingTop: 1,
      backgroundColor: theme.palette.primary.light,
      color: 'white',
      border: `2px solid ${
        theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900]
      }`,
    },
  },
  shoppingCartLink: {
    '& $shoppingBagBadge': {
      top: 7,
      right: 5,
      width: 20,
      height: 20,
      paddingTop: 1,
      color: 'white',
      backgroundColor: theme.palette.primary.light,
      border: `2px solid ${
        theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900]
      }`,
    },
  },
  userMenuItem: {
    '& $orderBadgeItem': {
      top: 11,
      right: -30,
    },
  },
  shoppingBagBadge: {
    top: 7,
    right: 5,
    width: 20,
    height: 20,
    paddingTop: 1,
    color: 'white',
    backgroundColor: theme.palette.primary.light,
    border: `2px solid ${
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900]
    }`,
  },
  orderBadge: {
    top: 5,
    right: 5,
    width: 20,
    height: 20,
    paddingTop: 1,
    backgroundColor: theme.palette.primary.light,
    color: 'white',
    border: `2px solid ${
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900]
    }`,
  },
  orderBadgeItem: {
    top: 11,
    right: -30,
  },
  badgeHidden: {
    display: 'none !important',
  },
  logoImage: {
    height: 30,
    verticalAlign: 'middle',
  },

  menuItemAnchor: {
    textDecoration: 'none',
    color: 'inherit',
  },

  signInButtons: {
    marginRight: 10,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  mobileLoggedOutMenu: {
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
});

export default makeStyles(styles);
